document.addEventListener("DOMContentLoaded", function() {
  // ========== 商品ページでの保存処理 ==========
  const el = document.querySelector("body[data-product-handle]");
  if (el) {
    const handle = el.getAttribute("data-product-handle");
    if (handle) {
      let cookie = (document.cookie.match(/(?:^|;\s*)recently_viewed=([^;]*)/) || [])[1] || '';
      let viewed = cookie ? decodeURIComponent(cookie).split(",") : [];

      // 重複除去 & 先頭追加
      viewed = viewed.filter(h => h && h !== handle);
      viewed.unshift(handle);

      // 最大10件保持
      if (viewed.length > 10) viewed = viewed.slice(0, 10);

      // 30日保持
      document.cookie =
        "recently_viewed=" + encodeURIComponent(viewed.join(",")) +
        "; path=/; max-age=2592000; SameSite=Lax";
    }
  }

  // ========== 最近見た商品の描画処理 ==========
  var container = document.getElementById("recently-viewed-list");
  var emptyMsg  = document.getElementById("recently-viewed-empty");
  if (!container) return; // セクションが存在しないページでは終了

  let cookie = (document.cookie.match(/(?:^|;\s*)recently_viewed=([^;]*)/) || [])[1] || '';
  let handles = cookie ? decodeURIComponent(cookie).split(",") : [];

  // スマホは最大3件、PCは最大5件
  var maxItems = window.innerWidth <= 768 ? 3 : 5;

  // 重複除去 → 最大件数だけ取得
  var seen = new Set();
  handles = handles.filter(h => h && !seen.has(h) && (seen.add(h), true))
    .slice(-maxItems).reverse();

  if (!handles.length) {
    emptyMsg.style.display = "block";
    return;
  }

  Promise.all(
    handles.map(h =>
      fetch(`/products/${h}?view=recent-card`).then(r => r.ok ? r.text() : '')
    )
  ).then(htmls => {
    let count = 0;
    htmls.forEach(html => {
      if (html) { container.insertAdjacentHTML('beforeend', html); count++; }
    });
    if (count === 0) emptyMsg.style.display = 'block';
  }).catch(() => {
    emptyMsg.style.display = 'block';
  });
});

document.addEventListener("click", function(e) {
  const btn = e.target.closest("#check-btn .add-to-cart-button");
  if (!btn) return;

  // ボタン内のテキスト要素を取得
  const addText = btn.querySelector(".add-to-cart-text");
  const addedText = btn.querySelector(".add-to-cart-text--added");

  // Ajax でカートに追加
  const variantId = btn.form.querySelector("[name='id']").value;

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(res => res.json())
});

document.addEventListener("click", function(e) {
  const btn = e.target.closest("#check-btn .add-to-cart-button");
  if (!btn) return;

  e.preventDefault(); // フォーム送信による遷移を止める

  const addText = btn.querySelector(".add-to-cart-text");
  const addedText = btn.querySelector(".add-to-cart-text--added");
  const variantId = btn.form.querySelector("[name='id']").value;

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(res => res.json())
});
